module.exports = __webpack_public_path__ + "media/images/header-0f6e29e7f4efc1fdde63c5e4bbf79e58.jpg";